<template>

    <div v-if="value_string" class="tw-flex tw-w-full">
        <h6 v-if="should_be_linked"><a :href="value_string">{{ value_string }}</a></h6>
        <h6 v-else>{{ value_string }}</h6>
    </div>

</template>

<script>
    export default {
        name: "MemberProfileInfoItem",
        props: {
            'text': {
                type: String,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'value': {
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        computed: {
            value_array() {
                return Array.isArray(this.value) ? this.value : [this.value]
            },
            value_string() {
                if (!Array.isArray(this.value_array)) {
                    return null
                }
                return this.value_array.join(', ')
            },
            should_be_linked() {
                let types_to_link = ['website','demo_reel']
                return types_to_link.includes(this.text)
            }
        },
        methods: {
            profileInfoForArrays(data_array, prop_name) {
                if (!data_array || !Array.isArray(data_array) || (Array.isArray(data_array) && data_array.length === 0)) return null
                return data_array.map(element => element[prop_name]).filter(element=>element)
            }
        }
    }
</script>

<style>
</style>
